import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/stt-video-1.webm")